import React from 'react'
import styled, { css } from 'styled-components'

import { ButtonUnstyled, truncateStyles } from '@sketch/components'

export interface OptionProps extends React.ButtonHTMLAttributes<any> {
  children?: React.ReactNode
  value?: string
  active?: boolean
}
const Option = styled(ButtonUnstyled)<OptionProps>(
  ({ theme, active }) => css`
    ${truncateStyles};

    display: block;
    width: 100%;
    min-width: 150px;

    margin: 0;
    padding: 8px 16px;

    background-color: ${theme.colors.background.secondary.A};

    color: ${active
      ? theme.colors.sketch.A
      : theme.colors.foreground.secondary.B};
    font-size: ${theme.fontSizes.D};
    font-weight: ${theme.fontWeights.regular};
    line-height: 1;
    text-align: left;

    cursor: pointer;
    transition: all ${theme.transitions.duration[1]};

    &:hover,
    &:focus {
      background-color: ${theme.colors.background.tertiary.C};
      color: ${theme.colors.foreground.secondary.A};
    }

    &.active {
      color: ${theme.colors.sketch.A};
    }

    &:first-child {
      margin-top: 8px;
    }

    & ~ &:last-child {
      margin-bottom: 8px;
    }

    user-select: none;
  `
)

export default Option
